import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solutionled(props) {
    return (
        <section className="solutionled p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Retail App">
                            <h2>Create A Custom Retail Management Software</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <p>TekRevol is a full-scale retail <Link
                            to="/custom-software-development">software development
                            company</Link> empowering business owners and
                            retailers with state-of-the-art inventory management and POS solutions to help them maximize
                            productivity and streamline core business operations. We build easy-to-use, all-inclusive
                            retail management softwares to enhance the efficiency of supply chain and logistic
                            operations, commercial operations, and POS operations for wholesalers and retailers.
                            We build retail software solutions for desktops and mobile devices to help business owners
                            reach a broader audience and uncover more revenue streams. </p>

                        <div className="btn_talk">
                            <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Solutionled;